/* eslint-disable jsdoc/valid-types */
/**
 * @template T
 * @typedef {T extends infer O ? { [K in keyof O]: O[K] } : never} Expand
 */

/**
 * @template T
 * @template {Readonly<string[]>} K
 * @typedef {Expand<Pick<T, Extract<keyof T, K[number]>>>} PickByKeys
 */

/**
 * @template {object} T
 * @template {Readonly<string[]>} K
 * @param {T} obj
 * @param {K} keys
 */
export function pickByKeys(obj, keys) {
  const entries = Object.entries(obj).filter(([key]) => keys.includes(key));
  return /** @type {PickByKeys<T, K>} */ (Object.fromEntries(entries));
}

/**
 * @template T
 * @typedef {T extends infer O ? { [K in keyof O]: Exclude<O[K], undefined> } : never} UndefinedRemoved
 */

/**
 * Returns a new object with all properties from the input object except those with `undefined` values.
 * @template {object} T
 * @param {T} obj - The input object.
 * @returns {UndefinedRemoved<T>} A new object with properties that have defined values.
 */
export function omitUndefinedValues(obj) {
  const entries = Object.entries(obj).filter(([, value]) => value !== undefined);
  return /** @type {UndefinedRemoved<T>} */ (Object.fromEntries(entries));
}
